<template>
  <div class="v-container">
    <div class="v-page-header">自然村列表</div>
    <div class="v-header">
      <div>
        <el-button @click="showAddEdit()" size="small" type="primary">新增自然村</el-button>
      </div>
      <div>
        <el-select size="small" v-model="live_status" placeholder="转码状态筛选" style="width: 170px" class="v-mr-5">
          <el-option :value="1" label="转码中"></el-option>
          <el-option :value="2" label="转码完成"></el-option>
        </el-select>
        <el-cascader v-if="userLevel != 3" v-model="regionData" placeholder="地域筛选" size="mini" :props="{ value: 'id', label: 'name', children: 'child', checkStrictly: true, expandTrigger: 'hover' }" :options="regionList" filterable style="width: 170px; margin-right: 5px" />
        <el-input v-model="keyword" class="v-form-item" size="mini" placeholder="自然村名称" style="width: 170px"></el-input>
        <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table border size="small" :data="lists" height="100%">
        <!--        <el-table-column label="ID" width="60" prop="id"></el-table-column>-->
        <el-table-column label="排序" width="60" prop="sort"></el-table-column>
        <el-table-column label="封面" width="100" align="center">
          <template slot-scope="scope">
            <img class="cover-preview" :src="scope.row.thumb_preview" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="自然村名称" width="200" >
          <template slot-scope="scope"><span v-if="scope.row.type == 2" class="v-color-blue">【复制】</span>{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="area_name" label="所属区域" width="150" />
        <el-table-column align="center" label="创建时间" width="160" prop="create_time"></el-table-column>
        <el-table-column align="center" label="是否推荐" width="90" fixed="right">
          <div class="recommend-box" slot-scope="scope">
            <el-switch element-loading-spinner="el-icon-loading" v-loading="scope.row.loadingRecommend" v-model="scope.row.is_recommend" :active-value="1" :inactive-value="2" @change="changeRecommend(scope.row)" active-color="#13ce66"></el-switch>
          </div>
        </el-table-column>
        <el-table-column v-if="config.WEB == 4" align="center" label="二维码" width="90" fixed="right">
          <template slot-scope="scope">
            <el-popover placement="top" trigger="click">
              <img :src="config.API_BASE + '/api/works/getQrcode?client-type=4&id=' + scope.row.id" style="width: 140px; height: 140px; margin: 0 auto; display: block" />
              <div slot="reference" class="link">查看二维码</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="right" label="操作" width="270" fixed="right">
          <template slot-scope="scope">
            <el-button @click="toPreview(scope.row)" size="min" class="v-ml-5" type="success" :disabled="scope.row.live_status == 1">
              {{ scope.row.live_status == 1 ? '转码中' : '预览' }}
            </el-button>
            <el-button @click="toConfig(scope.row)" size="min" class="v-ml-5" type="warning" :disabled="scope.row.live_status == 1 || scope.row.type == 2">配置</el-button>
            <!--            <el-button v-if="config.ENV == 'development'" @click="remake(scope.row)" size="min" class="v-ml-5" type="primary" :disabled="scope.row.live_status == 1">复拍</el-button>-->
            <el-button :disabled="scope.row.type == 2" @click="showPlan(scope.row)" size="min" class="v-ml-5" type="danger">任务</el-button>
            <el-button :disabled="scope.row.type == 2" @click="showVrCopy(scope.row)" size="min" class="v-ml-5" icon="el-icon-copy-document"></el-button>
            <el-button :disabled="scope.row.type == 2" @click="showAddEdit(scope.row)" size="min" class="v-ml-5" icon="el-icon-edit"></el-button>
            <el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
              <el-button slot="reference" size="min" class="v-ml-5" icon="el-icon-delete" :loading="scope.row.deleteLoading"></el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="v-footer">
      <el-pagination layout="total,sizes,prev, pager, next" @size-change="page_size => getList(page, page_size)" @current-change="page => getList(page)" :current-page.sync="page" :total="total"></el-pagination>
    </div>
    <vr-add-edit v-if="isShowAddEdit" :show.sync="isShowAddEdit" :row="row" @success="page => getList(page)" />
    <vr-add-scene v-if="isShowAddScene" :show.sync="isShowAddScene" :row="row" @success="page => getList(page)" />
    <vr-remake v-if="isShowRemake" :show.sync="isShowRemake" :row="row" @success="getList" />
    <vr-plan v-if="isShowPlan" :show.sync="isShowPlan" :row="row" />
    <vr-copy v-if="isShowVrCopy" :show.sync="isShowVrCopy" :row="row" @success="getList" />
  </div>
</template>

<script>
	import vrAddEdit from './components/vr-add-edit';
	import vrAddScene from './components/vr-add-scene';
	import vrRemake from './components/vr-remake';
	import vrPlan from './components/vr-plan';
	import vrCopy from './components/vr-copy';

	export default {
		components: {vrAddEdit, vrRemake, vrAddScene, vrPlan ,vrCopy},

		data() {
			return {
				config: this.config,
				page: 1,
				page_size: 10,
				total: 0,
				lists: [],
				live_status: '',
				isShowAddEdit: false,
				isShowAddScene: false,
				isShowRemake: false,
				isShowPlan: false,
				row: false,
				loading: false,
				keyword: '',
				regionList: [],
				regionData: [],
				userLevel: this.$store.getters.userInfo.level,
        isShowVrCopy:false,
			};
		},

		mounted() {
			this.getList();
			this.getAreaList();
		},

		methods: {
			//全景列表
			async getList(page, page_size) {
				this.loading = true;
				this.page = page ? page : this.page;
				this.page_size = page_size ? page_size : this.page_size;
				try {
					let res = await this.api.works.lists({
						page: this.page,
						page_size: this.page_size,
						keyword: this.keyword,
						area_id: this.regionData.length ? this.regionData[this.regionData.length - 1] : '',
						live_status: this.live_status,
					});
					this.lists = res.data.data;
					this.total = res.data.total;
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			reset() {
				this.regionData = [];
				this.keyword = '';
				this.live_status = '';
				this.getList(1);
			},

			showAddEdit(row) {
				this.row = row || null;
				this.isShowAddEdit = true;
			},

			//地域列表
			async getAreaList() {
				try {
					this.regionList = await this.$store.dispatch('user/getAreaList');
				} catch (e) {
					console.error(e);
				}
			},

      showVrCopy(row){
				this.row = row;
				this.isShowVrCopy = true;
      },

			//删除
			async doDelete(row) {
				this.$set(row, 'deleteLoading', true);
				try {
					await this.api.works.delete({id: row.id});
					this.$message.success('删除成功');
					this.getList(1);
				} catch (e) {
					console.error(e);
				}
				this.$set(row, 'deleteLoading', false);
			},

			//配置作品
			async toConfig(row) {
				if (row.has_material == 1) {
					let routeUrl = this.$router.resolve({
						path: '/tour',
						query: {id: row.id},
					});
					window.open(routeUrl.href, '_blank');
				} else {
					this.row = row;
					this.isShowAddScene = true;
				}
			},

			//预览作品
			async toPreview(row) {
				if (row.has_material == 1) {
					let routeUrl = this.$router.resolve({
						path: '/preview',
						query: {id: row.origin_id ||  row.id},
					});
					window.open(routeUrl.href, '_blank');
				} else {
					this.row = row;
					this.isShowAddScene = true;
				}
			},

			showPlan(row) {
				this.row = row;
				this.isShowPlan = true;
			},

			//切换推荐状态
			async changeRecommend(row) {
				this.$set(row, 'loadingRecommend', true);
				try {
					let data = {
						works_id: row.id,
						area_id: row.area_id,
						name: row.name,
						works_category_id: row.works_category_id, //分类id
						material_ids: row.material_ids, //资源id
						thumb: row.thumb,
						sort: row.thumb,
						is_recommend: row.is_recommend,
					};
					await this.api.works.edit(data);
					this.$message.success('更新成功');
				} catch (e) {
					console.error(e);
				}
				this.$set(row, 'loadingRecommend', false);
			},

			//复拍
			remake(row) {
				this.row = row;
				this.isShowRemake = true;
			},
		},
	};
</script>

<style scoped>
  .v-header {
    display: flex;
    justify-content: space-between;
  }

  .cover-preview {
    display: block;
    height: 60px;
    margin: 0 auto;
  }

  .category-name {
    color: #3582d1;
  }

  .link {
    color: #3582d1;
    cursor: pointer;
  }

  .recommend-box /deep/ .el-loading-spinner {
    margin-top: -10px;
  }
</style>
